var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 142,
    height: 126,
    viewBox: "0 0 142 126",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1429_1699)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_1429_1699",
    maskUnits: "userSpaceOnUse",
    x: 0.693604,
    y: 0.0273438,
    width: 141,
    height: 125,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 0.693604,
    y: 0.0273438,
    width: 141,
    height: 125
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.22 1.02734H41.0462C17.5179 1.02734 1.6936 15.6643 1.6936 37.4353V87.6808C1.6936 109.39 17.5179 124.027 41.0462 124.027H101.22C124.749 124.027 140.504 109.39 140.504 87.6808V37.4353C140.504 15.6643 124.749 1.02734 101.22 1.02734"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M101.22 1.02734H41.0462C17.5179 1.02734 1.6936 15.6643 1.6936 37.4353V87.6808C1.6936 109.39 17.5179 124.027 41.0462 124.027H101.22C124.749 124.027 140.504 109.39 140.504 87.6808V37.4353C140.504 15.6643 124.749 1.02734 101.22 1.02734",
    fill: "#00B695",
    fillOpacity: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.22 2.02734C101.773 2.02734 102.22 1.57963 102.22 1.02734C102.22 0.475059 101.773 0.0273438 101.22 0.0273438V2.02734ZM101.22 0.0273438C100.668 0.0273438 100.22 0.475059 100.22 1.02734C100.22 1.57963 100.668 2.02734 101.22 2.02734V0.0273438ZM101.22 0.0273438H41.0462V2.02734H101.22V0.0273438ZM41.0462 0.0273438C29.075 0.0273438 18.98 3.75345 11.8677 10.3332C4.74859 16.9192 0.693604 26.2958 0.693604 37.4353H2.6936C2.6936 26.8039 6.55079 17.9765 13.2259 11.8013C19.9078 5.61974 29.4892 2.02734 41.0462 2.02734V0.0273438ZM0.693604 37.4353V87.6808H2.6936V37.4353H0.693604ZM0.693604 87.6808C0.693604 98.7905 4.74915 108.152 11.8682 114.73C18.9803 121.301 29.075 125.027 41.0462 125.027V123.027C29.4891 123.027 19.9075 119.435 13.2255 113.261C6.55022 107.093 2.6936 98.2807 2.6936 87.6808H0.693604ZM41.0462 125.027H101.22V123.027H41.0462V125.027ZM101.22 125.027C113.192 125.027 123.27 121.301 130.365 114.729C137.466 108.15 141.504 98.7891 141.504 87.6808H139.504C139.504 98.2821 135.663 107.094 129.006 113.262C122.341 119.435 112.777 123.027 101.22 123.027V125.027ZM141.504 87.6808V37.4353H139.504V87.6808H141.504ZM141.504 37.4353C141.504 26.2972 137.467 16.9206 130.365 10.334C123.27 3.75355 113.192 0.0273438 101.22 0.0273438V2.02734C112.777 2.02734 122.341 5.61964 129.005 11.8004C135.663 17.9751 139.504 26.8025 139.504 37.4353H141.504Z",
    fill: "url(#paint0_linear_1429_1699)",
    mask: "url(#path-1-outside-1_1429_1699)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bd_1429_1699)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_1429_1699",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.8604 82.5023C61.3058 82.5023 59.7511 81.9796 58.5643 80.9279L42.0944 66.334C39.7208 64.2307 39.7208 60.8236 42.0944 58.7264C44.4681 56.6231 48.3062 56.617 50.6798 58.7203L62.8604 69.5135L91.5108 44.1263C93.8845 42.023 97.7226 42.023 100.096 44.1263C102.47 46.2296 102.47 49.6367 100.096 51.74L67.1566 80.9279C65.9698 81.9796 64.4151 82.5023 62.8604 82.5023"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.8604 82.5023C61.3058 82.5023 59.7511 81.9796 58.5643 80.9279L42.0944 66.334C39.7208 64.2307 39.7208 60.8236 42.0944 58.7264C44.4681 56.6231 48.3062 56.617 50.6798 58.7203L62.8604 69.5135L91.5108 44.1263C93.8845 42.023 97.7226 42.023 100.096 44.1263C102.47 46.2296 102.47 49.6367 100.096 51.74L67.1566 80.9279C65.9698 81.9796 64.4151 82.5023 62.8604 82.5023",
    fill: "url(#paint1_linear_1429_1699)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0944 58.7264L42.2269 58.8763L42.2271 58.8761L42.0944 58.7264ZM62.8604 69.5135L62.7278 69.6632L62.8604 69.7807L62.9931 69.6632L62.8604 69.5135ZM100.096 51.74L99.9636 51.5903L99.9636 51.5903L100.096 51.74ZM67.1566 80.9279L67.2892 81.0776L67.2892 81.0776L67.1566 80.9279ZM62.8604 82.3023C61.3493 82.3023 59.8433 81.7941 58.6969 80.7782L58.4316 81.0776C59.6588 82.165 61.2622 82.7023 62.8604 82.7023V82.3023ZM58.6969 80.7782L42.2271 66.1843L41.9618 66.4836L58.4316 81.0776L58.6969 80.7782ZM42.2271 66.1843C39.9431 64.1604 39.9435 60.8937 42.2269 58.8763L41.962 58.5765C39.4981 60.7534 39.4985 64.3009 41.9618 66.4836L42.2271 66.1843ZM42.2271 58.8761C44.5253 56.8396 48.2495 56.834 50.5472 58.8699L50.8125 58.5706C48.3629 56.3999 44.4109 56.4066 41.9618 58.5767L42.2271 58.8761ZM50.5472 58.8699L62.7278 69.6632L62.9931 69.3638L50.8125 58.5706L50.5472 58.8699ZM62.9931 69.6632L91.6434 44.276L91.3782 43.9766L62.7278 69.3638L62.9931 69.6632ZM91.6434 44.276C93.9414 42.2398 97.6656 42.2398 99.9636 44.276L100.229 43.9766C97.7795 41.8062 93.8275 41.8062 91.3782 43.9766L91.6434 44.276ZM99.9636 44.276C102.247 46.2997 102.247 49.5666 99.9636 51.5903L100.229 51.8897C102.692 49.7068 102.692 46.1595 100.229 43.9766L99.9636 44.276ZM99.9636 51.5903L67.024 80.7782L67.2892 81.0776L100.229 51.8897L99.9636 51.5903ZM67.024 80.7782C65.8775 81.7941 64.3716 82.3023 62.8604 82.3023V82.7023C64.4586 82.7023 66.062 82.165 67.2892 81.0776L67.024 80.7782Z",
    fill: "url(#paint2_linear_1429_1699)",
    fillOpacity: 0.5,
    mask: "url(#path-3-inside-2_1429_1699)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1429_1699",
    x: -23.3064,
    y: -23.9727,
    width: 188.81,
    height: 173,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1429_1699"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1429_1699",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bd_1429_1699",
    x: 25.3142,
    y: 27.5488,
    width: 91.5623,
    height: 69.9531,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1429_1699"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.454902 0 0 0 0 0.870588 0 0 0 0 0.376471 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1429_1699",
    result: "effect2_dropShadow_1429_1699"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1429_1699",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1429_1699",
    x1: 23.7899,
    y1: 15.357,
    x2: 99.7544,
    y2: 121.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1429_1699",
    x1: 97.5117,
    y1: 49.7636,
    x2: 29.0372,
    y2: 53.2037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1429_1699",
    x1: 46.9458,
    y1: 55.9513,
    x2: 99.2185,
    y2: 56.3959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessImg);
export default __webpack_public_path__ + "static/media/successImg.4c786b50904e9ef289c33b048726f1e9.svg";
export { ForwardRef as ReactComponent };